module.exports = __webpack_public_path__ + "static/media/male-img.b27c5c5d.png";